import { IEntity } from '@pf/shared-common';
import {
    ContactFragment,
    PurchaseOrderHeaderFragment,
    RequisitionLineFragment,
    RequisitionPriority,
    RequisitionSearchRequestParams,
    RequisitionStatus,
    RequisitionViewModelCreateBody,
    RequisitionViewModelRead,
    ResourceAuth,
    WarehouseFragment,
} from '@control-tower/platform-wms';
import { IWarehouseEntity } from '../interfaces/warehouse-entity';
import { CustomFieldDto } from '@pf/shared/util-platform';

export type RequisitionRead = RequisitionViewModelRead & IEntity;
export type RequisitionCreate = RequisitionViewModelCreateBody;
export type RequisitionSearchParams = RequisitionSearchRequestParams;

export class RequisitionDto implements IWarehouseEntity {
    constructor(data: Partial<RequisitionDto>) {
        Object.assign(this, data);
    }
    id!: string;
    status!: RequisitionStatus;
    warehouse!: WarehouseFragment;
    isDeleted?: boolean;
    createdDate?: string;
    modifiedDate?: string;
    priority!: RequisitionPriority;
    notes?: string | null;
    expectedBy?: string | null;
    resourceAuth?: ResourceAuth;
    externalReferenceId?: string | null;
    requestingContact?: ContactFragment;
    purchaseOrder?: PurchaseOrderHeaderFragment;
    requisitionLines?: Array<RequisitionLineFragment> | null;
    customFields?: Array<CustomFieldDto> | null;
}
